// extracted by mini-css-extract-plugin
export var cardIcon = "_ac-4";
export var checkboxCard = "_ac-0";
export var checkboxCardSelected = "_ac-3";
export var disabled = "_ac-1";
export var outerBorder = "_ac-2";
export var spacerMedium = "_ac-7";
export var spacerSmall = "_ac-6";
export var spacerXsmall = "_ac-5";